import React, { Component } from "react";
import ProjectTable from "./ProjectTable";
import BsyTurnPage from "../BsyTurnPage";
import BsySLoading from "../BsySLoading";
import { BsyUtils } from "../../utils/Utils";
import { dayjsUtils } from "../../utils/dayjsUtils";

class HistoryVersion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      count: 0,
      limit: 20,
      selectVal: props.data || {},
      keyword: "",
      header: [
        {
          name: React.language("version.number"),
          id: "versionHis",
        }, {
          name: React.language("release.time"),
          id: "timeHis",
        }, {
          name: React.language("update.cont"),
          id: "contHis",
        }, {
          name: React.language("doc.link"),
          id: "linkHis",
        }, {
          name: React.language("version.download"),
          id: "downHis",
        }
      ],
      data: [],
      isLoading: true
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { skip, limit, selectVal, keyword } = this.state;
    this.setState({ isLoading: true }, () => {
      React.axios("/dashboard/standard_app_list", {
        keyword: keyword,
        _id: selectVal._id,
        skip: skip * limit,
        limit
      }).then(res => {
        const { list, count } = res.data;
        this.setState({ data: list, count, isLoading: false })
      })
    })

  }

  skipChange = (e) => {
    this.setState({
      skip: e
    }, () => {
      this.loadData();
    })
  }

  listLimitChange = (e) => {
    this.setState({
      limit: e,
      skip: 0
    }, () => {
      this.loadData();
    })
  }

  downloadApp = (version) => {
    return () => {
      const { selectVal } = this.state;
      window.open(`/dashboard/standard_app_down/${selectVal._id}/${version}`);
    }
  }

  render() {
    const { limit, skip, count, header, data, isLoading } = this.state;
    return <div className="InstallUpdateLog">
      <div className="ProjectTable">
        {isLoading && <BsySLoading style={{ background: '#ffffff' }} />}
        <div className="table-content">
          <div className="content-header">
            <div className="header-tr">
              {
                header.map(res => {
                  return <div className={`header-td ${res.id}`}>{res.name}</div>
                })
              }
            </div>
          </div>
          <div className="content-body">
            {
              data.map((res, key) => {
                return <div className={`body-tr ${key % 2 === 0 ? "" : "even"}`}>
                  <div className={`body-td versionHis`}>{res.version}</div>
                  <div className={`body-td timeHis`}>{BsyUtils.date2Str(dayjsUtils.timeToTZ(res.createTime), "yyyy-MM-dd HH:mm:ss")}</div>
                  <div className={`body-td contHis`} title={res.remark}><input type="text" value={res.remark} readOnly={true} /></div>
                  <div className={`body-td linkHis`}><span title={res.docUrl}
                    style={{ cursor: "pointer" }}
                    onClick={e => {
                      e.preventDefault();
                      BsyUtils.redirectTo(res.docUrl, "_blank");
                    }} >{res.docUrl}</span></div>
                  <div className={`body-td downHis`}>
                    <div className="td-download" onClick={this.downloadApp(res.version)}>
                      <i className="icon-bsy-reportmenu-8"></i>
                      <span>{React.language('download')}</span>
                    </div>
                  </div>
                </div>
              })
            }
          </div>
        </div>
      </div>
      <BsyTurnPage skipChange={this.skipChange} listLimitChange={this.listLimitChange} limit={limit} skip={skip} count={count} />
    </div>
  }
}

export default HistoryVersion;